import { render, staticRenderFns } from "./MitgliederProbenbenefit.vue?vue&type=template&id=11f5021e&"
import script from "./MitgliederProbenbenefit.vue?vue&type=script&lang=js&"
export * from "./MitgliederProbenbenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports